import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import OfficeResponseResource from "common/resources/Office/OfficeResponseResource";
import Button, { EButtonVariant } from "components/elements/Button";
import Table from "components/elements/Table";
import { ECellType, IRowProps, TableColumn } from "components/elements/Table/MuiTable";
import I18n from "components/materials/I18n";
import { useCallback, useEffect, useState } from "react";
import OfficeService from "services/OfficeService";
import { container } from "tsyringe";
import classes from "./classes.module.scss";

const officeService = container.resolve(OfficeService);

type IProps = {
	onSelectOffice: (officeId: string) => void;
};

export default function OfficesList({ onSelectOffice }: IProps) {
	const [rows, setRows] = useState<IRowProps[]>([]);

	const onSearch = useCallback((search: string) => officeService.get(search).then((products) => setRows(buildRows(products, onSelectOffice))), [onSelectOffice]);

	useEffect(() => {
		officeService.get().then((offices) => setRows(buildRows(offices, onSelectOffice)));
	}, [onSelectOffice]);
	return <Table columnsHead={columnsHead} rows={rows} placeholderSearchbar={I18n.asset.common.search} onNext={null} onSearch={onSearch} />;
}

function buildRows(offices: OfficeResponseResource[], onSelectOffice: (id: string) => void): IRowProps[] {
	return offices.map((office) => {
		return {
			rowKey: office.id,
			numero: office.numero,
			raisonSociale: office.raisonSociale,
			membreReseau: office.membreReseau ?? "",
			numberOfSubscriptions: office.numberOfSubscriptions,
			userLastLoginAt: office.userLastLoginAt ? new Date(office.userLastLoginAt) : null,
			createdAt: office.createdAt ? new Date(office.createdAt) : null,
			select: (
				<Button variant={EButtonVariant.TEXT} onClick={() => onSelectOffice(office.id)}>
					{I18n.asset.common.select}
					<ArrowLongRightIcon className={classes["icon"]} />
				</Button>
			),
		};
	});
}

const columnsHead: readonly TableColumn[] = [
	{
		headContent: I18n.asset.pages.partners.table.columns.id,
		key: "numero",
	},
	{
		headContent: I18n.asset.pages.partners.table.columns.raison_social,
		key: "raisonSociale",
	},
	{
		headContent: I18n.asset.pages.partners.table.columns.reseau,
		key: "membreReseau",
	},
	{
		headContent: I18n.asset.pages.partners.table.columns.creation_date,
		key: "createdAt",
		formatType: ECellType.DATE,
	},
	{
		headContent: I18n.asset.pages.partners.table.columns.number_of_subscriptions,
		key: "numberOfSubscriptions",
	},
	{
		headContent: I18n.asset.pages.partners.table.columns.last_login_at,
		key: "userLastLoginAt",
		formatType: ECellType.DATE,
	},
	{
		headContent: "",
		key: "select",
	},
];
